export const onDomReady = ((onDomReady) => {
	onDomReady = callback => {
		const isIE = ! (!document.attachEvent || typeof document.attachEvent === "undefined");
		
		if(! (callback && typeof callback === 'function'))
			throw new Error('callback() is not a valid callback');
			
		if(! isIE) {
            document.addEventListener('DOMContentLoaded', () => {
				return callback();
            });
            
			return;
		}
		
		document.attachEvent('onreadystatechange', () => {
			if(document.readyState === 'complete')
				return callback();
		});
	}
	
	return onDomReady;
})(onDomReady || {});





export const getWindowDimensions = function() {
	const w = window,
		  d = document,
		  e = d.documentElement,
		  b = d.getElementsByTagName('body')[0],
		  x = w.innerWidth || e.clientWidth || b.clientWidth,
		  y = w.innerHeight || e.clientHeight || b.clientHeight;
	
	return { width: x, height: y };
};




/* 
 * debounce
 *
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing.
 *
 * USAGE: 
 *
 * 	var myEfficientFn = debounce(() => {
 *		// All the taxing stuff you do
 *	}, 250);
 *  window.addEventListener('resize', myEfficientFn);
 */
 
export const debounce = function(func, wait, immediate) {
	let timeout;
	return () => {
		const context = this;
		const args = arguments;
		
		const later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};






/* 
 * poll
 *
 * As I mentioned with the debounce function, sometimes you don't get to plug into an event to signify a desired state 
 * if the event doesn't exist, you need to check for your desired state at intervals:
 *
 * USAGE: 
 *
 *	// Usage:  ensure element is visible
 *	poll(() => {
 *		return document.getElementById('lightbox').offsetWidth > 0;
 *	}, 2000, 150).then(() => {
 *    	// Polling done, now do something else!
 *	}).catch(() => {
 *   	// Polling timed out, handle the error!
 *	});
 */
export const poll = function(fn, timeout, interval) {
    const endTime = Number(new Date()) + (timeout || 2000);
    interval = interval || 100;
	
    var checkCondition = (resolve, reject) => {
        // If the condition is met, we're done! 
        const result = fn();
        if(result) {
            resolve(result);
        }
        // If the condition isn't met but the timeout hasn't elapsed, go again
        else if (Number(new Date()) < endTime) {
            setTimeout(checkCondition, interval, resolve, reject);
        }
        // Didn't match and too much time, reject!
        else {
            reject(new Error('timed out for ' + fn + ': ' + arguments));
        }
    };

    return new Promise(checkCondition);
};




/* 
 * once
 *
 * There are times when you prefer a given functionality only happen once, similar to the way you'd use an onload event.  
 * This code provides you said functionality:
 *
 * USAGE: 
 * 
 *	var canOnlyFireOnce = once(() => {
 *		console.log('Fired!');
 *	});
 *
 *	canOnlyFireOnce(); // "Fired!"
 *	canOnlyFireOnce(); // nada
 */

export const once = function(fn, context) { 
	let result;

	return () => { 
		if(fn) {
			result = fn.apply(context || this, arguments);
			fn = null;
		}

		return result;
	};
};



/*
 * getAbsoluteUrl
 *
 * Getting an absolute URL from a variable string isn't as easy as you think.
 * There's the URL constructor but it can act up if you don't provide the required arguments (which sometimes you can't).
 * Here's a suave trick for getting an absolute URL from and string input:
 *
 * USAGE :
 *
 * getAbsoluteUrl('/something'); // returns https://domain.com/something
 */
export const getAbsoluteUrl = function(url) {
	let a;

	return url => {
		if(!a) a = document.createElement('a');
		a.href = url;

		return a.href;
	};
};



